import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Services } from "../components/Services";
import { WhyUs } from "../components/WhyUs";
import { CTA } from "../components/CTA";
import { Footer } from "../components/Footer";
import { FloatingWA } from "../components/FloatingWA";
import { Pricing } from "../components/Pricing";
import { About } from "../components/About";

export function Home() {
  return `
    ${Navbar()}
    ${Hero()}
    ${Services()}
    ${WhyUs()}
    ${CTA()}
    ${FloatingWA()}
    ${Pricing()}
    ${About()}
    ${Footer()}
  `;
}
